import SentInvitations from './SentInvitations';

export default SentInvitations;
